import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { API_URL, useAuth } from "./../../AuthContext.js";
import Logger from "../../utils/Logger";
import { useNotification } from "../../components/NotificationContext";
import httpClient from "../../services/httpClient.js";
import ContactTable from "../../components/ContactTable";
import sortIcon from "../../media/sort-icon.svg";
import { downloadFile } from "../../services/download.js";

const ContactNiviss = () => {
  const { t } = useTranslation();
  const [departments, setDepartments] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const { showNotification } = useNotification();
  const { userData } = useAuth();

  // Sprawdź czy użytkownik ma uprawnienia administratora
  const isAdmin = () => {
    return (
      userData?.userRole === "admin" || userData?.userRole === "hr-manager"
    );
  };

  // Funkcja dla przycisku "Drukuj bazę (Maritex + Niviss)" - pobiera PDF z backendu
  const handleExtraButton = async () => {
    try {
      setLoading(true);

      await downloadFile(
        `Users/pdf`,
        () => {
          // showNotification(
          //   "Baza teleadresowa została pobrana pomyślnie!",
          //   "success"
          // );
        },
        (progress) => {
          // Opcjonalnie można wyświetlić progress
          if (progress > 0) {
            Logger.info(`Pobieranie: ${progress}%`);
          }
        },
      );
    } catch (error) {
      Logger.error("Błąd podczas pobierania bazy teleadresowej:", error);
      // showNotification(
      //   `Błąd podczas pobierania bazy teleadresowej: ${error.message}`,
      //   "error"
      // );
    } finally {
      setLoading(false);
    }
  };

  // Funkcja obsługi edycji przekazywana do ContactTable
  const handleEdit = async (item, editValues) => {
    try {
      const updateData = {
        firstName: editValues.firstName ?? item.firstName,
        lastName: editValues.lastName ?? item.lastName,
        email: editValues.email ?? item.email,
        internalPhoneNumber:
          "internalPhoneNumber" in editValues
            ? editValues.internalPhoneNumber
            : (item.internalPhoneNumber ?? null),
        phoneNumber:
          "phoneNumber" in editValues
            ? editValues.phoneNumber
            : (item.phoneNumber ?? null),
        mobilePhoneNumber:
          "mobilePhoneNumber" in editValues
            ? editValues.mobilePhoneNumber
            : (item.mobilePhoneNumber ?? null),
        departmentId: editValues.departmentId ?? item.departmentId,
      };

      await httpClient.put(`/Users/${item.id}`, updateData, { withAuth: true });
      // showNotification("Zmiany zapisane!", "success");
      fetchContacts();
    } catch (error) {
      Logger.error("Błąd podczas edycji pracownika:", error);
      // showNotification("Błąd podczas edycji pracownika", "error");
    }
  };

  // Funkcja obsługi usuwania przekazywana do ContactTable
  const handleDelete = async (selectedEmployee) => {
    try {
      await httpClient.delete(`/Users/${selectedEmployee.id}`, {
        withAuth: true,
      });
      // showNotification("Pracownik został usunięty pomyślnie!", "success");
      fetchContacts();
    } catch (error) {
      Logger.error("Błąd podczas usuwania pracownika:", error);
      // showNotification("Błąd podczas usuwania pracownika", "error");
    }
  };

  // Pobieranie działów z API
  const fetchDepartments = async () => {
    try {
      const response = await httpClient.get("Departments", {
        withAuth: true,
      });
      // Sortowanie działów alfabetycznie po nazwie
      const sortedDepartments = response.data.sort((a, b) =>
        (a?.name || "").localeCompare(b?.name || "", "pl", {
          sensitivity: "base",
        }),
      );
      setDepartments(sortedDepartments);
    } catch (error) {
      Logger.error("Błąd podczas pobierania działów:", error);
      // showNotification("Błąd podczas pobierania działów", "error");
    }
  };

  // Pobieranie danych z API
  useEffect(() => {
    fetchContacts();
    fetchDepartments();
  }, []);

  const fetchContacts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await httpClient.get("users/company/niviss", {
        withAuth: true,
      });

      // Axios: response.data contains the parsed JSON
      setContactData(response.data);
    } catch (error) {
      setError(error.message);
      Logger.error("Błąd podczas pobierania pracowników:", error);
      // showNotification("Błąd podczas pobierania pracowników", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContactTable
      title={t("contactDatabase.title") + " Niviss"}
      createButtonLabel={t("contactDatabase.createEmployee")}
      createButtonLink="/administrator/baza-teleadresowa/niviss/nowy-pracownik"
      contactData={contactData}
      departments={departments}
      loading={loading}
      error={error}
      isAdmin={isAdmin()}
      onEdit={handleEdit}
      onDelete={handleDelete}
      extraButton={{
        label: t("contactDatabase.printDatabase"),
        onClick: handleExtraButton,
        icon: sortIcon,
      }}
      searchOptions={[
        { key: "firstName", label: t("contactDatabase.firstName") },
        { key: "lastName", label: t("contactDatabase.lastName") },
        { key: "email", label: t("contactDatabase.email") },
        { key: "department", label: t("contactDatabase.department") },
      ]}
    />
  );
};

export default ContactNiviss;
